function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.003 490.003",
    style: {
      enableBackground: "new 0 0 490.003 490.003"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43CAED"
    },
    d: "M490.003,245.002c0,105.97-67.28,196.23-161.45,230.38c-26.07,9.46-54.21,14.62-83.55,14.62   c-12.96,0-25.68-1.01-38.1-2.95c-15.69-2.45-30.89-6.39-45.45-11.67c-94.17-34.15-161.45-124.41-161.45-230.38   c0-135.31,109.69-245,245-245S490.003,109.692,490.003,245.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EE7FE"
    },
    d: "M488.333,216.332c-2.01,17.34-5.84,34.13-11.29,50.17c-7.54,22.2-18.18,42.97-31.41,61.8   c-44.31,63.11-117.65,104.36-200.63,104.36c-82.97,0-156.31-41.25-200.63-104.35c-13.23-18.83-23.87-39.6-31.41-61.81   c-5.45-16.04-9.28-32.83-11.29-50.17c7.56-64.85,40.44-121.97,88.49-161.21c14.19-11.58,29.7-21.61,46.28-29.82   c23.38-11.57,48.86-19.52,75.73-23.12c10.74-1.44,21.7-2.18,32.83-2.18s22.09,0.74,32.83,2.18c26.87,3.6,52.36,11.55,75.74,23.13   c16.57,8.2,32.08,18.23,46.27,29.81C447.893,94.361,480.773,151.482,488.333,216.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE26B"
    },
    d: "M328.553,447.812v27.57c-26.07,9.46-54.21,14.62-83.55,14.62s-57.48-5.16-83.55-14.62v-27.57   c29.83-22.17,40.71-54.93,44.66-93.9c2.1-20.61,2.25-42.95,2.25-66.39h73.27c0,23.44,0.16,45.78,2.25,66.39   C287.843,392.881,298.723,425.642,328.553,447.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB247"
    },
    d: "M283.883,353.912c-12.35,5.99-25.39,9.19-38.88,9.19h-0.18c-9.98-0.02-18.44,7.36-19.44,17.29   c-2.75,27.35-8.09,50.48-18.48,67.42v39.24c-15.69-2.45-30.89-6.39-45.45-11.67v-27.57c14.91-11.08,25.09-24.82,32.03-40.65   c6.95-15.83,10.66-33.77,12.63-53.25c2.1-20.61,2.25-42.95,2.25-66.39h73.27C281.633,310.962,281.793,333.301,283.883,353.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE26B"
    },
    d: "M385.255,110.277c0,130.271-62.79,235.884-140.25,235.884s-140.26-105.612-140.26-235.884   c0-27.898,2.88-54.655,8.17-79.485h264.17C382.375,55.621,385.255,82.378,385.255,110.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB247"
    },
    d: "M271.456,119.344c5.389,0,9.757-4.368,9.757-9.757v-6.83c0-5.389-4.368-9.757-9.757-9.757h-52.912   c-5.389,0-9.757,4.368-9.757,9.757v6.83c0,5.389,4.368,9.757,9.757,9.757h7.262c4.053,0,7.339,3.286,7.339,7.339v80.588   c0,4.053-3.286,7.339-7.339,7.339h-7.262c-5.389,0-9.757,4.368-9.757,9.757v6.83c0,5.389,4.368,9.757,9.757,9.757h52.912   c5.389,0,9.757-4.368,9.757-9.757v-6.83c0-5.389-4.368-9.757-9.757-9.757h-7.262c-4.053,0-7.339-3.286-7.339-7.339v-80.588   c0-4.053,3.286-7.339,7.339-7.339H271.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB247"
    },
    d: "M245.005,346.16c-77.46,0-140.26-105.61-140.26-235.88c0-27.9,2.88-54.66,8.17-79.49h59.38   c-2.91,24.83-4.49,51.59-4.49,79.49C167.805,240.55,202.365,346.16,245.005,346.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB247"
    },
    d: "M158.97,244.329c-85.845-3.434-124.746-37.812-142.263-66.046   c-21.222-34.206-19.841-73.863-9.06-97.993c5.75-12.868,15.718-21.437,28.828-24.782c40.709-10.384,101.26,32.531,118.849,45.931   l-13.332,17.5C101.584,88.155,62.302,71.624,41.913,76.825c-6.638,1.693-11.144,5.646-14.18,12.439   c-8.412,18.826-9.303,50.065,7.668,77.419c14.71,23.71,48.242,52.614,124.448,55.663L158.97,244.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE26B"
    },
    d: "M331.03,244.329l-0.879-21.982c76.206-3.048,109.737-31.952,124.448-55.663   c16.971-27.354,16.08-58.594,7.668-77.419c-3.036-6.794-7.542-10.747-14.18-12.44c-20.385-5.203-59.67,11.33-100.08,42.114   l-13.332-17.5c17.589-13.4,78.143-56.315,118.85-45.931c13.109,3.344,23.078,11.914,28.828,24.782   c10.782,24.129,12.162,63.787-9.06,97.993C455.776,206.517,416.875,240.895,331.03,244.329z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB247"
    },
    d: "M395.629,27.33c0,5.27-2.135,10.051-5.593,13.51c-3.458,3.458-8.24,5.593-13.51,5.593H113.474    c-10.555,0-19.103-8.555-19.103-19.103c0-5.278,2.135-10.052,5.593-13.51c3.458-3.458,8.232-5.601,13.51-5.601h263.052    C387.073,8.219,395.629,16.774,395.629,27.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE26B"
    },
    d: "M395.629,27.33c0,5.27-2.135,10.051-5.593,13.51c-3.458,3.458-8.24,5.593-13.51,5.593H168.58    c-10.548,0-19.103-8.555-19.103-19.103c0-5.278,2.135-10.052,5.593-13.51c3.458-3.458,8.24-5.601,13.51-5.601h207.945    C387.073,8.219,395.629,16.774,395.629,27.33z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEB247"
    },
    d: "M428.533,195.482v24.71c-13.01,7.31-28.88,13.6-48.22,17.96v-22.62   c20.58-5.2,36.23-12.82,48.12-21.32C428.493,194.622,428.533,195.042,428.533,195.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5B67"
    },
    d: "M387.811,294.034v-82.302c0-2.799,1.56-5.365,4.045-6.654l33.226-17.229   c4.989-2.587,10.946,1.034,10.946,6.654v99.53l-24.109-18.244L387.811,294.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF297B"
    },
    d: "M425.082,187.85l-33.226,17.229c-2.485,1.289-4.045,3.854-4.045,6.654v14.986   c0-2.799,1.56-5.365,4.045-6.654l33.226-17.229c4.989-2.587,10.946,1.034,10.946,6.654v-14.986   C436.028,188.883,430.072,185.262,425.082,187.85z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy1);
export default __webpack_public_path__ + "static/media/trophy-1.f77aed1f.svg";
export { ForwardRef as ReactComponent };